import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import { CASINO_VIDEO_URL } from "../../utils/constants";
import CasinoPage from "./components/CasinoPage";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { getCasinoExposureAPI, getCasinoOddsAPI } from "../../service/casino";
export default function Card32A() {
  const GAME_ID = "CARD_32";
  const VIDEO_ID = 3056;
  const dispatch = useDispatch();

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );
  const [casinoPlData, setCasinoPlData] = useState([]);
  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={CASINO_VIDEO.thirtyTwoCardA}
      GAME_ID={GAME_ID}
      shortName={"cards32a"}
      gameName={"Card 32"}
    >
      <div
        _ngcontent-ng-c1798067373=""
        className="casino-table ng-tns-c1798067373-7 ng-star-inserted"
      >
        <div
          _ngcontent-ng-c1798067373=""
          className="casino-table-box ng-tns-c1798067373-7"
        >
          <div
            _ngcontent-ng-c1798067373=""
            className="casino-table-left-box ng-tns-c1798067373-7"
          >
            <div
              _ngcontent-ng-c1798067373=""
              className="casino-table-header ng-tns-c1798067373-7"
            >
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-nation-detail ng-tns-c1798067373-7"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="min_max_odds justify-content-start d-lg-none d-flex ng-tns-c1798067373-7"
                >
                  <span
                    _ngcontent-ng-c1798067373=""
                    className="min_max_span ms-0 ng-tns-c1798067373-7"
                  >
                    <b
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      Min:
                    </b>
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {" "}
                      100 {/**/}
                      {/**/}
                    </span>
                  </span>
                  <span
                    _ngcontent-ng-c1798067373=""
                    className="min_max_span ms-1 ng-tns-c1798067373-7"
                  >
                    <b
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      Max:
                    </b>
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {" "}
                      100000 {/**/}
                      {/**/}
                    </span>
                  </span>
                </div>
              </div>
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-odds-box back ng-tns-c1798067373-7"
              >
                Back
              </div>
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-odds-box lay ng-tns-c1798067373-7"
              >
                Lay
              </div>
            </div>
            <div
              _ngcontent-ng-c1798067373=""
              className="casino-table-body ng-tns-c1798067373-7"
            >
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-table-row ng-tns-c1798067373-7 ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="casino-nation-detail ng-tns-c1798067373-7"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="casino-nation-name ng-tns-c1798067373-7"
                  >
                    {" "}
                    Player 8{" "}
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 8")}
                    </p>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1798067373=""
                  className={`ng-tns-c1798067373-7 casino_odds_row ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                >
                  <div
                    onClick={() =>
                      setBet("Player 8", casinoData, dispatch, "back")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box back ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 8", casinoData, true)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {" "}
                      {getOddForEntity("Player 8", casinoData, true, true)}
                    </p>
                  </div>
                  <div
                    onClick={() =>
                      setBet("Player 8", casinoData, dispatch, "lay")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box lay ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 8", casinoData, false)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 8", casinoData, false, true)}
                    </p>
                  </div>
                </div>
              </div>
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-table-row ng-tns-c1798067373-7 ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="casino-nation-detail ng-tns-c1798067373-7"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="casino-nation-name ng-tns-c1798067373-7"
                  >
                    {" "}
                    Player 9{" "}
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 9")}
                    </p>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1798067373=""
                  className={`ng-tns-c1798067373-7 casino_odds_row ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }
              }`}
                >
                  <div
                    onClick={() =>
                      setBet("Player 9", casinoData, dispatch, "back")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box back ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 9", casinoData, true)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {" "}
                      {getOddForEntity("Player 9", casinoData, true, true)}
                    </p>
                  </div>
                  <div
                    onClick={() =>
                      setBet("Player 9", casinoData, dispatch, "lay")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box lay ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 9", casinoData, false)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 9", casinoData, false, true)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            _ngcontent-ng-c1798067373=""
            className="casino-table-box-divider ng-tns-c1798067373-7"
          />
          <div
            _ngcontent-ng-c1798067373=""
            className="casino-table-right-box ng-tns-c1798067373-7"
          >
            <div
              _ngcontent-ng-c1798067373=""
              className="casino-table-header d-none d-md-flex ng-tns-c1798067373-7"
            >
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-nation-detail ng-tns-c1798067373-7"
              />
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-odds-box back ng-tns-c1798067373-7"
              >
                Back
              </div>
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-odds-box lay ng-tns-c1798067373-7"
              >
                Lay
              </div>
            </div>
            <div
              _ngcontent-ng-c1798067373=""
              className="casino-table-body ng-tns-c1798067373-7"
            >
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-table-row ng-tns-c1798067373-7 ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="casino-nation-detail ng-tns-c1798067373-7"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="casino-nation-name ng-tns-c1798067373-7"
                  >
                    {" "}
                    Player 10{" "}
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 10")}
                    </p>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1798067373=""
                  className={`ng-tns-c1798067373-7 casino_odds_row ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }
              }`}
                >
                  <div
                    onClick={() =>
                      setBet("Player 10", casinoData, dispatch, "back")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box back ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 10", casinoData, true)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {" "}
                      {getOddForEntity("Player 10", casinoData, true, true)}
                    </p>
                  </div>
                  <div
                    onClick={() =>
                      setBet("Player 10", casinoData, dispatch, "lay")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box lay ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 10", casinoData, false)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 10", casinoData, false, true)}
                    </p>
                  </div>
                </div>
              </div>
              {/**/}
              {/**/}
              <div
                _ngcontent-ng-c1798067373=""
                className="casino-table-row ng-tns-c1798067373-7 ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c1798067373=""
                  className="casino-nation-detail ng-tns-c1798067373-7"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="casino-nation-name ng-tns-c1798067373-7"
                  >
                    {" "}
                    Player 11{" "}
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getCasinoPlExposureByRunner(casinoPlData, "Player 11")}
                    </p>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1798067373=""
                  className={`ng-tns-c1798067373-7 casino_odds_row ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }
              }`}
                >
                  <div
                    onClick={() =>
                      setBet("Player 11", casinoData, dispatch, "back")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box back ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 11", casinoData, true)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {" "}
                      {getOddForEntity("Player 11", casinoData, true, true)}
                    </p>
                  </div>
                  <div
                    onClick={() =>
                      setBet("Player 11", casinoData, dispatch, "lay")
                    }
                    _ngcontent-ng-c1798067373=""
                    className="casino-odds-box lay ng-tns-c1798067373-7"
                  >
                    <span
                      _ngcontent-ng-c1798067373=""
                      className="casino-odds ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 11", casinoData, false)}
                    </span>
                    <p
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-7"
                    >
                      {getOddForEntity("Player 11", casinoData, false, true)}
                    </p>
                  </div>
                </div>
              </div>
              {/**/}
              {/**/}
              {/**/}
            </div>
          </div>
        </div>
      </div>
    </CasinoPage>
  );
}
